import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
export default class PodiumSection extends Component {
  view() {
    const entries = this.attrs.entries;
    if (entries.length === 0) {
      return null;
    }
    const pointsLabel = app.forum.attribute('huseyinfiliz-leaderboard.points_label') || 'Points';

    // Display order: 2nd, 1st, 3rd (desktop uses CSS order, mobile overrides)
    const ordered = [entries[1], entries[0], entries[2]].filter(Boolean);
    return m("div", {
      className: "LeaderboardPodium"
    }, ordered.map(entry => {
      const rank = entry.rank();
      const user = entry.user();
      const placeClass = `LeaderboardPodium-place--${rank}`;
      const medalClass = rank === 1 ? 'gold' : rank === 2 ? 'silver' : 'bronze';
      return m(Link, {
        href: user ? app.route('user', {
          username: user.slug()
        }) : '#',
        className: `LeaderboardPodium-place ${placeClass}`,
        key: entry.id()
      }, m("div", {
        className: `LeaderboardPodium-medal LeaderboardPodium-medal--${medalClass}`
      }, rank === 1 && m("i", {
        className: "fas fa-crown LeaderboardPodium-crown"
      }), m("span", {
        className: "LeaderboardPodium-rankNumber"
      }, "#", rank)), m("div", {
        className: "LeaderboardPodium-avatar"
      }, user ? m(Avatar, {
        user: user
      }) : m("span", {
        className: "Avatar"
      }, "?")), m("div", {
        className: "LeaderboardPodium-name"
      }, user ? user.displayName() : '?'), m("div", {
        className: "LeaderboardPodium-points"
      }, entry.points(), " ", pointsLabel), user && this.statsView(user));
    }));
  }
  statsView(user) {
    const comments = user.attribute('commentCount');
    const discussions = user.attribute('discussionCount');
    const badges = user.attribute('badgeCount');
    return m("div", {
      className: "LeaderboardPodium-stats"
    }, m("span", {
      className: "LeaderboardPodium-stat",
      title: app.translator.trans('huseyinfiliz-leaderboard.forum.podium.stat_comments')
    }, m("i", {
      className: "fas fa-comment"
    }), comments ?? 0), m("span", {
      className: "LeaderboardPodium-stat",
      title: app.translator.trans('huseyinfiliz-leaderboard.forum.podium.stat_discussions')
    }, m("i", {
      className: "fas fa-comments"
    }), discussions ?? 0), badges !== undefined && badges !== null && m("span", {
      className: "LeaderboardPodium-stat",
      title: app.translator.trans('huseyinfiliz-leaderboard.forum.podium.stat_badges')
    }, m("i", {
      className: "fas fa-certificate"
    }), badges));
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'forum/components/PodiumSection', PodiumSection);